export enum UserTypes {
  SUPER_ADMIN = 'Super Admin',
  BUSINESS_OWNER = 'Business Owner',
  BUSINESS_ADMIN = 'Business Admin',
  BUSINESS_MANAGER = 'Business Manager',
  EMPLOYEE = 'Employee',
  DRIVER = 'Driver',
  CUSTOMER = 'Customer',
  INSTALLER = 'Installer',
}

export const FEATURE_FLAG_LAUNDROWORKS_CUSTOMER_SYNC = 'laundroworks-customer-sync';
export const FEATURE_FLAG_LAUNDROWORKS_INTEGRATION = 'hasLWIntegration';
export const FEATURE_FLAG_LAUNDRYCAT_CUSTOMER_SYNC = 'laundrycat-customer-sync';

export enum LwSubscriptionStatus {
  PROVISIONAL = 'PROVISIONAL',
  ACTIVE = 'ACTIVE',
  CHURNED = 'CHURNED',
  SUSPENDED = 'SUSPENDED',
}

export enum RecordSource {
  CENTS = 'CENTS',
  LAUNDROWORKS = 'LAUNDROWORKS',
}
